module.exports = __webpack_public_path__ + "static/media/person-sign.2c6a5985.svg";